import type { DocumentActionContext } from '@quipex/shared/contracts';
import type { QuippyMessage, QuippyScope } from '../models';
import { isCanonicalDocumentId } from '../source-document-id';

export function documentActionContext(
    messages: readonly QuippyMessage[],
    scope: QuippyScope
): DocumentActionContext {
    const sourceSets = messages
        .filter(
            (message) =>
                message.role === 'assistant' && message.status === 'sent'
        )
        .map((message) => ({
            sourceSetId: message.id,
            documents: message.sources.flatMap((source) => {
                const buildingId =
                    source.buildingId ??
                    (scope.kind === 'building' ? scope.buildingId : null);
                if (
                    !isCanonicalDocumentId(source.id) ||
                    !isCanonicalDocumentId(buildingId)
                )
                    return [];
                return [
                    { documentId: source.id, buildingId, title: source.title },
                ];
            }),
        }))
        .filter((set) => set.documents.length > 0);
    return { enabled: true, sourceSets };
}
